/**
 * Enum detonating the type of error to display
 */
export enum ErrorType {
    Network,
    Generic,
}

export interface ErrorScreenText {
    /**
     * Title Text
     */
    text: string;
    /**
     * Ref attached to the title element
     */
    ref?: React.MutableRefObject<HTMLDivElement>;
    /**
     * Title Styles
     */
    className?: string;
}

export interface ActionButton {
    /**
     * Label for the action button
     */
    label?: string;

    /**
     * Icon for the action button
     */
    icon?: string;

    /**
     * Function triggers on click on the action button
     */
    onClick?: () => void;

    /**
     * Aria-label of the action button
     */
    ariaLabel?: string;

    /**
     * Custom styles for the button
     */
    className?: string;

    /**
     * action button has pop up or not
     */
    ariaHasPopup?: boolean;
}

export interface ErrorScreenProps {
    /**
     * Error Image
     */
    image?: JSX.Element | JSX.IntrinsicElements;

    /**
     * Override styles for the image class name
     */
    imageClassName?: string;

    /**
     * Title on the error screen
     */
    title?: ErrorScreenText;

    /**
     * Sub-title on the error screen
     */
    subtitle?: ErrorScreenText;

    /**
     * Action button on the error Screen.
     */
    actionButton?: ActionButton;

    /**
     * Callback function to be called when the toast times out and goes away
     */
    onTimeout?: () => void;

    /**
     * shows error screen in Full Screen
     */
    isFullScreen?: boolean;

    /**
     * By default we show action button on Error Screen
     * This prop will have default value as True.
     */
    showDefaultActionButton?: boolean;

    /**
     * Styles applied on the container class
     */
    containerClassName?: string;
}

export interface GenericErrorIconProps {
    /**
     * Changes svg for dark mode
     */
    isDarkMode?: boolean;
}
